// vendor
import React from "react";
import { Row, Container } from "reactstrap";
import { Link } from "react-router-dom";

// app
import { CreditsFooter, ContactSection, StyledFooter } from "./styled";



function MainFooter() {
  return (
    <StyledFooter className="footer footer-black">
      <Container>
        <Row>
          <nav className="footer-nav" aria-label="Footer navigation">
            <ul>
              <li>
                <Link to="/texas-property-tax-protest">
                  Texas Property Tax Protest
                </Link>
              </li>
              <li>
                <Link to="/how-to-protest-property-taxes">How To Protest</Link>
              </li>
              <li>
                <Link to="/property-tax-protest-deadlines-2026">Deadlines</Link>
              </li>
              <li>
                <Link to="/property-tax-protest-evidence">Evidence</Link>
              </li>
              <li>
                <Link to="/texas-homestead-exemption-guide">Homestead Exemption</Link>
              </li>
              <li>
                <Link to="/property-tax-glossary">Glossary</Link>
              </li>
              <li>
                <Link to="/texas-property-tax-timeline-2026">Tax Calendar</Link>
              </li>
              <li>
                <Link to="/property-tax-protest-companies-comparison">
                  Service Comparison
                </Link>
              </li>
              <li>
                <Link to="/pricing">Pricing</Link>
              </li>
              <li>
                <Link to="/faq">FAQ</Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy</Link>
              </li>
              <li>
                <ContactSection>
                  <i className="fa fa-envelope" aria-hidden="true" />
                  <a href="mailto:help@protestingpropertytaxes.com">
                    help@protestingpropertytaxes.com
                  </a>
                </ContactSection>
              </li>
            </ul>
          </nav>
          <CreditsFooter className="credits">
            <span className="copyright">
              © {new Date().getFullYear()}, made with{" "}
              <i className="fa fa-heart heart" aria-hidden="true" /> in Austin.
            </span>
          </CreditsFooter>
        </Row>
      </Container>
    </StyledFooter>
  );
}

export default MainFooter;
